import { createAsyncThunk } from '@reduxjs/toolkit';
import { PREFERENCE, selectPreferences } from '@socialive/common';
import { setPreference } from '@socialive/preferences';

export default createAsyncThunk('portal/migrate', async ({ storage, trigger }, { dispatch, getState }) => {
  const migratePreferences = !selectPreferences(getState())[PREFERENCE.MIGRATION_DATE];

  if (migratePreferences) {
    const reload = Object.entries(storage).reduce((result, [key, value]) => {
      const update = localStorage.getItem(key) !== value;
      if (update) {
        localStorage.setItem(key, value);
      }
      return update || result;
    }, false);

    await dispatch(setPreference({ key: PREFERENCE.MIGRATION_DATE, value: Date.now() }));

    if (reload) {
      // NOTE: localStorage is non-eventing and data has changed. We need to reload.
      window.location.reload();
    }
  }

  return { migratePreferences };
});
